export const fleetSizeOptions: string[] = ['1-49', '50-499', '500-4999', '5000+'];
